import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addclassandsection } from "../../store/slices/getstandardsection";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import {
  fetchStandards,
  fetchSection,
} from "../../store/slices/classandsection";
import { Link } from "react-router-dom";

export default function AddClassandSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    standards = [],
    sections = [],
    loading,
  } = useSelector((state) => state.classandsection || {});

  const [formData, setFormData] = useState({
    standardId: "",
    attendanceType: "",
  });

  const [selectedSections, setSelectedSections] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchStandards());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchSection());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "standardId") {
      const selected = standards.find((item) => item._id === value);

      setFormData({
        standardId: value,
        attendanceType: selected?.attendanceType || "",
      });

      setSelectedSections([]);
      setErrors({});
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* Section checkbox */
  const handleCheckboxChange = (id) => {
    setSelectedSections((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );

    setErrors((prev) => ({ ...prev, sectionIds: "" }));
  };

  /*  Validation */
  const validate = () => {
    let temp = {};

    if (!formData.standardId) {
      temp.standardId = "Please select standard";
    }

    if (!formData.attendanceType) {
      temp.attendanceType = "Please select attendance type ";
    }

    if (!selectedSections.length) {
      temp.sectionIds = "Please select at least one section";
    }

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      standardId: formData.standardId,
      attendanceType: formData.attendanceType,
      sectionIds: selectedSections,
    };

    dispatch(addclassandsection(payload))
      .unwrap()
      .then(() => {
        toast.success("Class & Section added successfully ");
        navigate("/institute/classandsection");
      })
      .catch((err) => {
        toast.error(err || "Failed to add Class & Section ");
      });
  };

  return (
    <>
      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />
            <Link to="/institute/classandsection">Class and Sections</Link>

            <FiChevronRight className="separator" />

            <span className="active">Add Class and Sections</span>
          </div>


        </div>

      </div>
      <div className="acs-card">

        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            <Col lg={3} md={4} sm={12}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>
                <Form.Select
                  name="standardId"
                  value={formData.standardId}
                  onChange={handleChange}
                >
                  <option value="">Select Standard</option>
                  {standards.map((item) => (
                    <option key={item?._id} value={item?._id}>
                      {item?.name}
                    </option>
                  ))}
                </Form.Select>
                {errors.standardId && (
                  <small className="text-danger">{errors.standardId}</small>
                )}
              </Form.Group>
            </Col>

            {/* Attendance */}
            <Col lg={3} md={4} sm={12}>
              <Form.Group>
                <Form.Label>Attendance Type</Form.Label>
                <Form.Select
                  name="attendanceType"
                  value={formData.attendanceType}
                  onChange={handleChange}
                >
                  <option value="">Select Attendance Type</option>
                  <option value="1">Once</option>
                </Form.Select>

                {errors.attendanceType && (
                  <small className="text-danger">{errors.attendanceType}</small>
                )}
              </Form.Group>
            </Col>

            {/* Sections */}
            <Col md={12} lg={6}>
              <Form.Group>
                <Form.Label>Sections</Form.Label>

                <div className="acs-checkbox-grid">
                  {sections.map((sec) => (
                    <label key={sec._id} className="acs-checkbox-item">
                      <input
                        type="checkbox"
                        checked={selectedSections.includes(sec._id)}
                        onChange={() => handleCheckboxChange(sec._id)}
                      />
                      <span>{sec.name}</span>
                    </label>
                  ))}
                </div>

                {errors.sectionIds && (
                  <small className="text-danger d-block mt-2">
                    {errors.sectionIds}
                  </small>
                )}

                {!sections.length && (
                  <p className="text-muted mt-2">
                    Select a standard to view sections
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Actions */}
          <div className="acs-actions mt-5">
            <button
              className="btn-cancel"

              type="button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button className="btn-submit" type="submit" disabled={loading}>
              Submit
            </button>
          </div>
        </Form>

      </div>
    </>
  );
}
